import React from 'react';
import BrowserFrame from './BrowserFrame';

const CloudArchitecture: React.FC = () => {
  return (
    <BrowserFrame url="miid.app/cloud/infra">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.8rem' }}>
          <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>Infrastructure Cloud</div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.3rem', padding: '.15rem .45rem', background: 'rgba(46,125,50,.12)', borderRadius: '2px' }}>
            <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#2E7D32', animation: 'livePulse 1.4s ease-in-out infinite' }} />
            <span style={{ fontSize: '.48rem', fontWeight: 700, color: '#2E7D32', letterSpacing: '.1em' }}>ALL HEALTHY</span>
          </div>
        </div>

        {/* Architecture diagram */}
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '3px', padding: '.8rem', marginBottom: '.6rem', position: 'relative', minHeight: '140px' }}>
          <svg viewBox="0 0 320 140" style={{ width: '100%', height: '140px' }}>
            <defs>
              <linearGradient id="cloudGrad" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="var(--blue)" stopOpacity=".4" />
                <stop offset="100%" stopColor="var(--blue)" stopOpacity=".8" />
              </linearGradient>
            </defs>

            {/* Connection lines */}
            <path d="M 40 30 L 100 30 L 100 70 L 160 70" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1.2" fill="none" />
            <path d="M 160 70 L 220 40" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1.2" fill="none" />
            <path d="M 160 70 L 220 100" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1.2" fill="none" />
            <path d="M 220 100 L 280 100" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1.2" fill="none" />
            <path d="M 220 40 L 280 40" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1.2" fill="none" />

            {/* Flow particles */}
            <circle r="2" fill="var(--gold)">
              <animateMotion dur="3s" repeatCount="indefinite" path="M 40 30 L 100 30 L 100 70 L 160 70" />
            </circle>
            <circle r="2" fill="var(--gold)">
              <animateMotion dur="2.5s" repeatCount="indefinite" path="M 160 70 L 220 40 L 280 40" />
            </circle>

            {/* Nodes */}
            {[
              { x: 20, y: 20, w: 40, h: 20, label: 'CDN', color: 'var(--gold-dark)' },
              { x: 80, y: 20, w: 50, h: 20, label: 'API GW', color: 'var(--blue)' },
              { x: 140, y: 60, w: 50, h: 20, label: 'Lambda', color: '#5E35B1' },
              { x: 200, y: 30, w: 40, h: 20, label: 'RDS', color: 'var(--blue-dark)' },
              { x: 200, y: 90, w: 40, h: 20, label: 'S3', color: '#2E7D32' },
              { x: 260, y: 30, w: 40, h: 20, label: 'Cache', color: '#C62828' },
              { x: 260, y: 90, w: 40, h: 20, label: 'Backup', color: 'var(--gold)' },
            ].map((n, i) => (
              <g key={i}>
                <rect x={n.x} y={n.y} width={n.w} height={n.h} rx="3" fill="var(--white)" stroke={n.color} strokeWidth="1.3" />
                <text x={n.x + n.w / 2} y={n.y + n.h / 2 + 3} textAnchor="middle" fill={n.color} fontFamily="'Montserrat', sans-serif" fontSize="6" fontWeight="700">
                  {n.label}
                </text>
              </g>
            ))}

            {/* Users arrow */}
            <path d="M 2 30 L 18 30" stroke="var(--ink2)" strokeWidth="1" fill="none" markerEnd="url(#arrow)" />
            <text x="2" y="22" fill="var(--ink2)" fontFamily="'Montserrat', sans-serif" fontSize="5" fontWeight="600">👥 Users</text>
          </svg>
        </div>

        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '.35rem' }}>
          {[
            { label: 'Uptime', value: '99.98%', color: 'var(--blue)' },
            { label: 'Latency', value: '42ms', color: '#2E7D32' },
            { label: 'Regions', value: '3', color: 'var(--gold-dark)' },
            { label: 'Instances', value: '24', color: '#5E35B1' },
          ].map((s) => (
            <div key={s.label} style={{
              background: 'var(--white)', border: '1px solid var(--border)',
              borderRadius: '3px', padding: '.35rem .45rem', textAlign: 'center',
            }}>
              <div style={{ fontSize: '.72rem', fontWeight: 700, color: s.color, fontFamily: "'Cormorant Garamond', serif", lineHeight: 1 }}>
                {s.value}
              </div>
              <div style={{ fontSize: '.42rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase', fontWeight: 600, marginTop: '.15rem' }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </BrowserFrame>
  );
};

export default CloudArchitecture;
